import DocumentVerifyIcon from "@svg/new-design/document-verified";
import { FC } from "react";

const gradients = {
  right:
    "https://faradars.org/wp-content/uploads/2025/04/29/gradient-right.svg",
  left: "https://faradars.org/wp-content/uploads/2025/04/29/gradient-left.svg",
};

const VerifyCertificateHeroSection: FC = () => {
  return (
    <div className="w-full bg-fds-brand min-h-[252px] md:min-h-[350px] relative">
      <div className="flex justify-center pt-8   lg:pt-fds-72">
        <img
          className="absolute top-0 right-0 h-full z-0 hidden lg:block"
          alt=""
          src={gradients.right}
        />
        <img
          className="absolute top-0 left-0 h-full z-0 hidden lg:block"
          alt=""
          src={gradients.left}
        />
        <section className="section-container relative flex flex-col h-full justify-between z-10">
          <div className="flex flex-col items-center w-full">
            <DocumentVerifyIcon className="mb-2 text-white" />
            <h1 className="text-fds-on-inverse headline-lg md:display-md">
              استعلام گواهینامه
            </h1>
            <p className="text-fds-on-inverse text-center body-md md:body-xlg px-4">
              فرادرس در مسیر یادگیری همراه شما است.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default VerifyCertificateHeroSection;
